export default "__VITE_ASSET__iICHRPss__"